export enum FormMode {
    Create = 0,
    Edit = 1
}
